










import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import MHButton from "../components/MHButton.vue";

@Component({
  components: {MHButton}
})
export default class LoadingButton extends Vue {
  @Prop() loading!: boolean;
  @Prop() text!: string;
  @Prop() type!: string;

  @Emit()
  click() {}
}
